import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { BasketService } from '../api/v2/basket.service';
import { BasketContents } from '../api/v2/Models/Basket/BasketContents';
import { BasketFormAnswer } from '../api/v2/Models/Basket/BasketFormAnswer';
import { MessagingConversationInput } from '../api/v2/Models/Basket/MessagingConversationInput';

@Injectable()
export class BasketStoreService {
	private currentBasketId: number | null = null;
	private currentBasket: BasketContents | null = null;
	get basket() {
		if (this.currentBasket) {
			return Promise.resolve({ data: this.currentBasket });
		}

		return this.basketService
			.getActive()
			.pipe(
				mergeMap((response) => {
					this.currentBasketId = response.data;

					return this.basketService.get(this.currentBasketId);
				}),
			)
			.toPromise();
	}

	get basketId() {
		return this.currentBasketId;
	}

	public setFormAnswers(formId: number, basketProductId: number, answers: BasketFormAnswer[]) {
		return this.basketService.setFormAnswers(this.basketId, formId, basketProductId, answers);
	}

	/**
	 * Get updated basket from database
	 */
	get updateBasket() {
		if (!this.currentBasketId) throw new Error('No basket found');

		return this.basketService.get(this.currentBasketId);
	}

	public addProductMessagingConversation(conversationInput: MessagingConversationInput) {
		if (!this.currentBasketId) throw new Error('No basket found');

		return this.basketService.addProductMessagingConversation(this.basketId, conversationInput);
	}

	public commit() {
		if (!this.currentBasketId) throw new Error('No basket found');

		return this.basketService.commit(this.basketId);
	}

	public removeItem(itemId: number) {
		if (!this.currentBasketId) throw new Error('No basket found');
		this.currentBasket = null;

		return this.basketService.removeItem(this.basketId, itemId);
	}

	public deleteBasketItem() {
		if (!this.currentBasketId) throw new Error('No basket found');
		const deleteId = this.currentBasketId;
		this.currentBasket = null;
		this.currentBasketId = null;

		return this.basketService.delete(deleteId);
	}

	public createCommit() {
		if (!this.currentBasketId) throw new Error('No basket found');

		return this.basketService.createCommit(this.basketId);
	}

	public getCommitStatus(commitJobId: number) {
		return this.basketService.getCommitStatus(commitJobId);
	}

	public deleteBasket() {
		if (!this.currentBasketId) throw new Error('No basket found');
		const deleteId = this.currentBasketId;
		this.currentBasket = null;
		this.currentBasketId = null;

		return this.basketService.delete(deleteId);
	}

	constructor(private basketService: BasketService) {}
}
